export default __webpack_public_path__ + "static/media/MBTorpedoOpen.2cb747c4.jpg";